<template>
  <div v-loading="loading">
    <ExamStudentForm
        :unlocked-tabs="unlockedTabs"
        :readonly="true"
        :type-exam="typeExam"
        :data-exam="dataExam"
        :question-index="questionIndex"
        :question-speaking-index="questionSpeakingIndex"
        :active-name="activeName"
        @handleChangeQuestion="handleChangeQuestion"
        @go-next="handleNext"
        @go-back="handleBack"
        @handleClick="handleClick"
        @update:active-name="(newActiveName) => activeName = newActiveName"
        @resetTab="resetTabs"
    />
  </div>
</template>

<script>
import ExamStudentForm from '@/view/pages/marking-exam/components/ExamStudentForm.vue'
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {SPEAKING, WRITING} from '@/common/courseTemplate.js'
import {getEvaluationTemplate} from '@/common/markingTemplate'
import {GET_EXAM_RESULT, GET_EXAM_WITH_ANSWER} from "@/core/services/store/marking/marking.module";

export default {
  name: 'ViewExamStudent',
  components: { ExamStudentForm },
  data() {
    return {
      loading: false,
      rubricKey: null,
      dataExam: [],
      unlockedTabs: [],
      questionIndex: 0,
      questionSpeakingIndex: 0,
      activeName: 'checkCheating',
    }
  },
  computed: {
    isWritingExam() {
      return [1, 7, 8].includes(+this.$route.query.type)
    },
    typeExam() {
      return this.isWritingExam ? WRITING : SPEAKING
    },
    route() {
      return this.$route
    }
  },
  watch: {
    questionIndex(newIndex, oldIndex) {
      if (newIndex === 1) {
        this.resetTabs()
        this.scrollToTop()
      }
    }
  },
  methods: {
    async getExamResult() {
      this.loading = true
      try {
        const examRes = await this.$store.dispatch(GET_EXAM_WITH_ANSWER, {
          marking_retake_id: this.$route.query.marking_retake_id,
          academic_task_id: this.$route.query.academic_task_id
        })
        const resultRes = await this.$store.dispatch(GET_EXAM_RESULT, {
          marking_exam_retake_id: this.$route.query.marking_retake_id,
          academic_task_id: this.$route.query.academic_task_id
        })
        if (examRes.error || resultRes.error) return

        const examData = examRes.data
        const resultData = resultRes.data

        this.rubricKey = examData?.rubric?.key

        if (this.typeExam === SPEAKING) {
          const speakingTemplate = this.getTemplate(this.rubricKey, SPEAKING)
          if (resultData && speakingTemplate.length > 0) {
            this.dataExam = [{
              questions: examData.data || [],
              cheating: resultData.cheating,
              items: this.mapTeacherMarksToTemplate(resultData.teacher_marks, speakingTemplate),
              didStudentDo: { value: resultData.has_submitted }

            }]
            this.unlockedTabs = [
              'checkCheating',
              ...speakingTemplate.map(g => g.key)
            ]
          }
        } else {
          const writingTemplate = this.getTemplate(this.rubricKey, WRITING)
          if (resultData && resultData.length > 0 && writingTemplate.length > 0) {
            this.dataExam = examData.data.map((writingTask, index) => ({
              questions: {...writingTask},
              cheating: resultData[index]?.cheating,
              items: this.mapTeacherMarksToTemplate(resultData[index]?.teacher_marks, this.getTemplate(this.rubricKey, WRITING, index)),
              didStudentDo: resultData[index]?.has_submitted,
              isAI: resultData[index]?.ai_scored
            }))
            this.unlockedTabs = [
              'checkCheating',
              ...writingTemplate.map(g => g.key)
            ]
         console.log(this.dataExam[1].items,'this.dataExam');
         
            
          }
        }
      } catch (error) {
        console.error('Lỗi khi lấy kết quả bài thi:', error)
      } finally {
        this.loading = false
      }
    },
    handleChangeQuestion(index) {
      if (this.typeExam === SPEAKING) {
        if (index >= 0 && index < (this.dataExam[0]?.questions?.length || 0)) {
          this.questionSpeakingIndex = index
        }
      } else {
        this.questionIndex = index
      }
    },
    handleClick(currentKey) {
      const template = this.getTemplate(this.rubricKey, this.typeExam, this.questionIndex)
      const keys = ['checkCheating', ...template.map(g => g.key)]
      const currentIndex = keys.findIndex(key => key === this.activeName)
      if (currentIndex < keys.length - 1) {
        this.activeName = keys[currentIndex + 1]
      }
    },
    handleNext() {
      const template = this.getTemplate(this.rubricKey, this.typeExam, this.questionIndex)
      const keys = ['checkCheating', ...template.map(g => g.key)]
      const currentIndex = keys.findIndex(key => key === this.activeName)
      if (currentIndex < keys.length - 1) {
        this.activeName = keys[currentIndex + 1]
      }
    },
    handleBack() {
      const template = this.getTemplate(this.rubricKey, this.typeExam, this.questionIndex)
      const keys = ['checkCheating', ...template.map(g => g.key)]
      const currentIndex = keys.findIndex(key => key === this.activeName)
      if (currentIndex > 0) {
        this.activeName = keys[currentIndex - 1]
      }
    },
    mapTeacherMarksToTemplate(teacherMarks, templateItems) {
      if (!teacherMarks || !templateItems) return []
      const marksMap = teacherMarks.reduce((acc, mark) => {
        if (!acc[mark.key_parent]) acc[mark.key_parent] = {}
        acc[mark.key_parent][mark.key] = mark
        return acc
      }, {})

      return templateItems.map(group => {
        const groupMarks = marksMap[group.key] || {}
        const commentDetail = Object.values(groupMarks)[0]?.comment_detail || ''

        const updatedItems = group.items.map(item => {
          const mark = groupMarks[item.key]
          return {
            ...item,
            criterion_score: mark ? mark.score : null,
            comment_auto: mark ? mark.comment_auto : ''
          }
        })

        return { ...group, items: updatedItems, comment_detail: commentDetail }
      })
    },
    getTemplate(rubricKey, examType, index = 0) {
      return getEvaluationTemplate(rubricKey, examType, index)?.items || []
    },
    resetTabs() {
      const firstKey = this.templateMark.items?.[0]?.key || ''
      this.unlockedTabs = ['checkCheating']
      if (firstKey) this.unlockedTabs.push(firstKey)
      this.activeName = 'checkCheating'
      this.isCheatingMarked = false
    },
    cloneDeep(value, seen = new WeakMap()) {
      if (value === null || typeof value !== 'object') {
        return value;
      }
      if (seen.has(value)) {
        return seen.get(value);
      }
      let clone;
      switch (true) {
        case value instanceof Date:
          clone = new Date(value);
          break
        case Array.isArray(value):
          clone = [];
          seen.set(value, clone);
          for (let i = 0; i < value.length; i++) {
            clone[i] = this.cloneDeep(value[i], seen);
          }
          break;
        case value instanceof Map:
          clone = new Map();
          seen.set(value, clone);
          value.forEach((v, k) => {
            clone.set(k, this.cloneDeep(v, seen));
          });
          break;
        case value instanceof Set:
          clone = new Set();
          seen.set(value, clone);
          value.forEach(v => {
            clone.add(this.cloneDeep(v, seen));
          });
          break;
        default:
          clone = Object.create(Object.getPrototypeOf(value));
          seen.set(value, clone);
          for (const key of Object.keys(value)) {
            clone[key] = this.cloneDeep(value[key], seen);
          }
      }
      return clone;
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {title: "Xem bài thi"},
      {title: "Danh sách tác vụ cá nhân"}
    ]);
    this.getExamResult()
  }
}
</script>
